export default __webpack_public_path__ + "img/github-icon.e1201fcc.svg";